import { render, staticRenderFns } from "./zsylink.vue?vue&type=template&id=84806718&scoped=true"
import script from "./zsylink.vue?vue&type=script&lang=js"
export * from "./zsylink.vue?vue&type=script&lang=js"
import style0 from "./zsylink.vue?vue&type=style&index=0&id=84806718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84806718",
  null
  
)

export default component.exports